module.exports = __webpack_public_path__ + "img/indesign.6395ef72.png";